import { render, staticRenderFns } from "./shortcutButtons.vue?vue&type=template&id=71b4810c&scoped=true&"
import script from "./shortcutButtons.vue?vue&type=script&lang=js&"
export * from "./shortcutButtons.vue?vue&type=script&lang=js&"
import style0 from "./shortcutButtons.vue?vue&type=style&index=0&id=71b4810c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71b4810c",
  null
  
)

export default component.exports